import EnumElement from '../../Table/EnumElement/EnumElement';
import Table, { ATTENDANCE_STATUS } from '../../Table/Table/Table';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import styles from './CommitmentsTeamMember.module.scss';
import React from 'react';
import { DummyUserPortrait } from '../../../User/Team/Meetings/Meeting/UserPortrait/UserPortrait';
import Button from '@mui/material/Button';
import { Add } from '@mui/icons-material';

export default function CommitmentsTeamMember(props) {
  const {
    cognitoId,
    firstName,
    lastName,
    commitments,
    attendance,
    addCommitment,
    editCommitment,
    isEditable,
    additionalHeaderContent = null,
  } = props;

  const editableTableProps = {
    rowFunction: editCommitment,
    rowFunctionIcon: <EditOutlinedIcon />,
    rowFunctionLabel: 'Edit',
  };

  return (
    <div className={styles.commitmentsTeamMember}>
      <div className={styles.header}>
        <div className={styles.name}>
          <DummyUserPortrait cognitoId={cognitoId} firstName={firstName} lastName={lastName} />
          <p>
            {firstName} {lastName}
          </p>
        </div>
        <div className={styles.details}>
          {additionalHeaderContent !== null && additionalHeaderContent}
          <EnumElement enumObject={ATTENDANCE_STATUS} value={attendance} />
        </div>
      </div>
      <div className={styles.commitmentsTable}>
        <Table
          skipHeader
          rows={[...commitments]}
          {...(isEditable ? editableTableProps : {})}
          keyColumn="id"
          columns={[
            {
              id: 'commitment',
              label: 'Commitment',
              component: true,
            },
            {
              id: 'value',
              label: 'Value',
              numeric: true,
            },
            {
              id: 'isAligned',
              label: 'Aligned',
              shrink: true,
              boolean: true,
            },
            {
              id: 'isTimely',
              label: 'Timely',
              shrink: true,
              boolean: true,
            },
            {
              id: 'isImpactful',
              label: 'Impactful',
              shrink: true,
              boolean: true,
            },
            {
              id: 'isSpecific',
              label: 'Specific',
              shrink: true,
              boolean: true,
            },
          ]}
        />
      </div>
      <div className={styles.newCommitment}>
        {isEditable && (
          <Button variant="text" startIcon={<Add />} onClick={addCommitment}>
            Add Commitment
          </Button>
        )}
      </div>
    </div>
  );
}
